import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function HomeFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M12 1.74609C12.5459 1.74609 13.0746 1.93878 13.4922 2.29004L22.4023 9.78516L22.4756 9.85352C22.8201 10.2088 22.8463 10.7746 22.5205 11.1611C22.2103 11.5287 21.6866 11.6091 21.2842 11.376V19.3174C21.2842 20.9347 19.9716 22.246 18.3525 22.2461H15V14.9961C15 14.4438 14.5522 13.9961 14 13.9961H10C9.44774 13.9961 9.00002 14.4438 9.00002 14.9961V22.2461H5.64748C4.02836 22.246 2.71584 20.9347 2.71584 19.3174V11.376C2.31337 11.6091 1.78968 11.5287 1.47951 11.1611C1.13205 10.7489 1.18519 10.1325 1.59768 9.78516L10.5088 2.29004L10.6699 2.16602C11.0582 1.89384 11.5223 1.7461 12 1.74609Z"
				fill="currentColor"
			/>
		</svg>
	);
}

HomeFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default HomeFilledIcon;
